import { useEffect } from 'react';
import { TurboModuleRegistry, Platform } from 'react-native';
import type { Spec } from '../../specs/NativeScreenWakeLock';

const ScreenWakeLock = Platform.OS !== 'web'
  ? TurboModuleRegistry.get<Spec>('ScreenWakeLock')
  : null;

/**
 * Prevents the screen from turning off while the component is mounted.
 * @param tag - Identifies the consumer for observability (e.g., 'story-builder', 'book-view')
 * @param enabled - Conditionally activate (e.g., only when voice is active)
 * No-op on web or old clients without the module.
 */
export function useKeepAwake(tag: string, enabled = true) {
  useEffect(() => {
    if (Platform.OS === 'web' || !ScreenWakeLock || !enabled) return;

    ScreenWakeLock.acquire(tag);
    return () => { ScreenWakeLock.release(tag); };
  }, [tag, enabled]);
}
